import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";
import { AuthenticationRepository } from "src/app/core/data/repository";
import { RoutesConstants } from "../common";

@Injectable({
  providedIn: 'root',
})
export class ThemeNotExistGuard implements CanActivate {
    constructor(private authenticationRepository: AuthenticationRepository, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const currentUser = this.authenticationRepository.currentUser$.value;
        const appType = this.authenticationRepository.getApplicationTypeFromToken();
        const availableUserAppTypes = currentUser.appsType;

        if(!appType && availableUserAppTypes.length) {
            return true;
        }

       this.router.navigate([RoutesConstants.DASHBOARD_PAGE_URL]);
       return false;
    } 
}